<script lang="ts">
	import { fly } from 'svelte/transition';
</script>

<div class="overlay">
	<div in:fly={{ y: 200, duration: 600, delay: 1000 }} class="content-wrapper">
		<slot />
	</div>
</div>

<style>
	.overlay {
		position: absolute;
		width: 300px;
		height: 500px;
		display: flex;
		align-items: center;
		justify-content: center;
		user-select: none;
		z-index: 1000;
	}
	.content-wrapper {
		max-width: 300px;
		border-radius: 10px;
		background-color: lightskyblue;
		box-shadow: 1px 0px 14px 5px rgba(0, 0, 0, 0.59);
	}
</style>
